import { createFileRoute } from '@tanstack/react-router';
import NewObjectPage from '@/pages/workspaces/objects/new-object.page';
import { ObjectsRoute } from '@/pages/workspaces/objects/routing';
import { RumPageRendered } from '@/services/rum/use-page-rendered';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/objects/$slug/new')({
  component: () => (
    <ObjectsRoute>
      <RumPageRendered>
        <NewObjectPage />
      </RumPageRendered>
    </ObjectsRoute>
  ),
});
